<div>
  <div class="col-md-12 col-lg-12">
    <div class="col-sm-4"><h4><b>{{ "pages.createReceiptPage.shipmentService.services" | translate }}</b></h4></div>
    <div [@openClose]="!isOpen ? 'open' : 'closed'">
      <div class="col-sm-2">&nbsp;</div>
      <div class="col-sm-3"><h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{ "common.change" | translate }}</h4></div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12 mrgin-lft mob-mrgin">
        <div class="details-container" [@openClose]="!isOpen ? 'open' : 'closed'">
          <div class="row">
            <div class="col-sm-4" *ngIf="selectedServices.length == 0">{{ "pages.createReceiptPage.shipmentService.noServiceSelectedMsg" | translate }}</div>
            <div *ngFor="let item of selectedServices; index as i">
              <div class="col-sm-2">{{item.Code}}</div>
              <div class="col-sm-2">{{item?.value}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="form-container" [@openClose]="isOpen ? 'open' : 'closed'">
  <div class="row center">
    <div class="col-md-2 col-sm-10" *ngFor="let service of services | orderBy : 'RequiresAmountToBeSpecified'; index as i">
      <div class="btn btn-lg btn-mode" (click)="selectServices(service)">
        <input type="checkbox"
               name="service-{{service.Code}}" [checked]="isSeletedService(service)?true:''"
               (change)="selectServices(service)"
               class="mrgn-right10p" />
        <span class="box-title">{{service.Code}}</span><p class="sub-box">{{service.Description}}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div *ngFor="let service of selectedServices | orderBy : 'RequiresAmountToBeSpecified'; index as i">
      <div *ngIf="service.RequiresAmountToBeSpecified" class="col-md-3">
        <div class="form-group">
          <label class="control-label">{{service.Code}} {{ "pages.createReceiptPage.shipmentService.serviceValue" | translate }}</label>
          <div class="input-group">
            <div class="inner-addon right-addon">
              <div class="row">
                <div class="col-md-8 col-sm-8" style="padding-right:0">
                  <input type="text" (change)="updateServiceValue($event.target.value,service.Code)" class="form-control curr-feild" placeholder="" #isFocus/>
                </div>
                <div class="col-md-4 col-sm-4" style="padding-left:0">
                  <select class="form-control curr-menu" [(ngModel)]="branchCurrencyCode" (change)="updateCurrancy($event.target.value,service.Code)">
                    <option *ngFor="let currency of currenceis" [selected]="currency.value==branchCurrencyCode">{{currency.value}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8">
      <div class="form-group">
        <button class="btn btn-primary" (click)="getServices()">{{ "common.next" | translate }}</button>
        <br />
        <span [innerHtml]="validationMessage"></span>
      </div>
    </div>
  </div>
</div>


